import React, { useState } from 'react';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';

import { controlledTextField } from 'components/ReactHookForm/controlledTextField';
import { SftpConfigSetInput } from 'generated/graphql';

type Props = {
  disableVisibilityControl?: boolean;
  onFocus?: () => void;
  required?: boolean;
  helperText?: string;
};

const PasswordControlledText = controlledTextField<Required<SftpConfigSetInput>>()('password');

const VisibilityButton = ({
  disableVisibilityControl,
  isPasswordVisible,
  setIsPasswordVisible,
}: {
  disableVisibilityControl?: boolean;
  isPasswordVisible: boolean;
  setIsPasswordVisible: (state: boolean) => void;
}): JSX.Element | null => {
  if (!disableVisibilityControl) {
    if (isPasswordVisible) {
      return (
        <VisibilityOffOutlinedIcon
          onClick={() => {
            setIsPasswordVisible(false);
          }}
          style={{ cursor: 'pointer' }}
        />
      );
    }

    return (
      <VisibilityOutlinedIcon
        onClick={() => {
          setIsPasswordVisible(true);
        }}
        style={{ cursor: 'pointer' }}
      />
    );
  }

  return null;
};

const PasswordInput: React.FC<Props> = ({
  disableVisibilityControl,
  onFocus,
  required,
  helperText,
}) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  return (
    <PasswordControlledText
      required={required}
      type={!disableVisibilityControl && isPasswordVisible ? 'text' : 'password'}
      label="Password"
      helperText={helperText}
      InputProps={{
        endAdornment: (
          <VisibilityButton
            {...{ disableVisibilityControl, isPasswordVisible, setIsPasswordVisible }}
          />
        ),
      }}
      controllerProps={{
        rules: {
          required,
        },
      }}
      onFocus={onFocus}
    />
  );
};

export default PasswordInput;
